"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styling = require("../../../toolkit/styling");

//
//  src/data/table/FixtureCell.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 9/17/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var _default = function _default(props) {
  var columnCount = props.columnCount,
      spanEntireRow = props.spanEntireRow,
      spanCount = props.spanCount,
      className = props.className,
      style = props.style,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["columnCount", "spanEntireRow", "spanCount", "className", "style", "children"]);
  var colSpanCount = 1;

  if (spanEntireRow) {
    colSpanCount = columnCount;
  } else if (spanCount) {
    colSpanCount = spanCount;
  }

  return /*#__PURE__*/_react["default"].createElement("td", (0, _extends2["default"])({
    colSpan: colSpanCount,
    className: (0, _styling.css)(className, style)
  }, otherProps), children);
};

exports["default"] = _default;